import useLogout from '@authentication/hooks/useLogout';
import useUser from '@authentication/hooks/useUser';
import LoginRequest from '@authentication/models/login.request.dto';
import LoginResponse from '@authentication/models/login.response.dto';
import { login } from '@authentication/services/authServices';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

const useLogoutMutation = (): UseMutationResult<
  AxiosResponse<LoginResponse>,
  unknown,
  LoginRequest,
  unknown
> => {
  const { setUser, setIsLoading } = useUser();

  const logout = useLogout();

  const onLogoutSuccess = ({ data }: { data: LoginResponse }) => {
    logout();
    setUser(null);
    setIsLoading(false);
  };

  const onLoginError = () => {
    setIsLoading(false);
  };
  const logoutMutation = useMutation({
    mutationFn: login,
    onSuccess: onLogoutSuccess,
    onError: onLoginError,
  });

  return logoutMutation;
};

export default useLogoutMutation;
